import { getIsDebugTestingActive } from './general'

export const logDevelopmentMessage = (message: string) => {
  const isDebugTestingActive = getIsDebugTestingActive()
  if (!isDebugTestingActive) return
  console.log('[Digital-conversations]', message)
}
